// extracted by mini-css-extract-plugin
module.exports = {"summary":"_2UscMS","title":"_1l3nhs","synopsis":"_1TesgD"};